import { EventEmitter, Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpService } from '../../../core/services/http.service';

import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LocalStorage as SessionStorage } from '../../../core/constants/local-storage';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

/**
 * common library services
 */

@Injectable({
  providedIn: 'root',
})
export class SideNavService {
  constructor(
    private httpService: HttpService,
    private http: HttpClient,
    private auth: AuthenticationService
  ) {}

  /**
   * Concatenate url with api end points for micro service
   *
   * @param url url to append with api end points
   *
   * @returns url
   */
  private composeUrl(url: string): string {
    return `${environment.host}/${url}`;
  }

  getContactDetail(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('family-profile?accountId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  updateUserData(token, formData): Observable<any> {
    return this.httpService
      .put(token, `${this.composeUrl('family-profile')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  updateServiceLevel(token, formData): Observable<any> {
    return this.httpService
      .put(token, `${this.composeUrl('billing/service-level')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  addSecondaryUser(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('family-profile/add-secondary-user')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  changeUserPassword(token, formData): Observable<any> {
    return this.httpService
      .put(token, `${this.composeUrl('user/change-password')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  // deleteLiability(token, id): Observable<any> {
  //   return this.httpService
  //     .delete(
  //       token,
  //       `${this.composeUrl('confirm-your-existing-liabilities/delete/' + id)}`
  //     )
  //     .pipe(catchError(this.handleError<any>('addNewProgram')));
  // }
  deleteExpense(token, id): Observable<any> {
    return this.httpService
      .delete(
        token,
        `${this.composeUrl('confirm-monthly-expense/delete/' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  // getAdress(token, id): Observable<any> {
  //   return this.httpService
  //     .get(token, `${this.composeUrl('register/address?contactId=' + id)}`)
  //     .pipe(catchError(this.handleError<any>('addNewProgram')));
  // }

  // goals and concerns
  getGoals(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('goals-and-concerns?accountId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  deleteGoalAndConcerns(token, id): Observable<any> {
    return this.httpService
      .delete(token, `${this.composeUrl('goals-and-concerns/' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  postGoalAndConcerns(token, formData): Observable<any> {
    return this.httpService
      .post(token, `${this.composeUrl('goals-and-concerns')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  postAllGoalAndConcerns(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('goals-and-concerns/all-goals')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  postAllGoalAndConcernsPriority(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('goals-and-concerns/all-goals-priority')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  rapidVOITrigger(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('family-profile/rapid-id-voi-flow')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getUserAllIncome(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('income/user-income-by-id?accountId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getMonthlyExpense(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('confirm-monthly-expense?contactId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getLiabilities(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'confirm-your-existing-liabilities/?accountId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  /// financial planning componment

  // goals and concerns
  getClientStrategyRecommendation(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'financial-planning/client-strategy-recommendation?accountId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getStrategyRecommendation(token): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('financial-planning/strategy-recommendation')}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getClientProductRecommendation(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'financial-planning/client-product-recommendation?accountId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getFinancialForecasts(token, accountId, contactId): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          `financial-planning/get-financial-forecasts?contactId=${contactId}&accountId=${accountId}`
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getNominatedBaneficary(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'death-benefit-nomination/nominated-beneficary?' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getInvestmentRiskProfile(token): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('family-profile/risk-profile')}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  postNominatedBeneficiaryStatus(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('family-profile/nominated-beneficiary-status')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  updateAddress(token, formData): Observable<any> {
    return this.httpService
      .put(token, `${this.composeUrl('register/single-address')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  uploadImage(token, formData, contactId): Observable<any> {
    const requestData = { ...formData, contactId };
    console.log('request data from service', requestData);
    return this.httpService
      .put(
        token,
        `${this.composeUrl('family-profile/uploadImage')}`,
        requestData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  deleteImage(token, id): Observable<any> {
    return this.httpService
      .delete(token, `${this.composeUrl('family-profile/delete/' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  // contact us
  getCashelTeam(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('contact-us?accountId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  // billing history
  getbillingHistory(token, id): Observable<any> {
    return this.httpService
      .get(token, `${this.composeUrl('billing?accountId=' + id)}`)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getAccountAdvice(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('billing/account-advice?accountId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getInvestmentAccount(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl('billing/investment-account?accountId=' + id)}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getInvestmentManager(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'investment-and-superannuation/investment-manager?investmentId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  hitDocumentCorePack(token, contactId, accountId, type): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          `investment-and-superannuation/document-core-pack-flow?contactId=${contactId}&accountId=${accountId}&type=${type}`
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getPerformanceAttribute(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'investment-and-superannuation/performance-attribute?pepl_investmentid=' +
            id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getTopTenHolding(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'investment-and-superannuation/top-ten-holding?parentInvestmentId=' +
            id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getGrowthSummary(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'investment-and-superannuation/investment-historical-price?investmentId=' +
            id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getInvestmentNews(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'investment-and-superannuation/investment-news?investmentId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getInvestmentbreakdown(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'investment-and-superannuation/investment-breakdown?investmentId=' +
            id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getTransactionData(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'investment-and-superannuation/transaction?investmentAccountId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getRiskMandateData(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'investment-and-superannuation/risk-mandate?sltaaId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  getInvestRelatedData(token, id): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'investment-and-superannuation/invest-related-data?accountId=' + id
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  getSharePointDocument(token, link): Observable<any> {
    return this.httpService
      .get(
        token,
        `${this.composeUrl(
          'investment-and-superannuation/sharepoint-document?sharePointlink=' +
            link
        )}`
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }
  // getSharePointDocument(token, link): Observable<any> {
  //   return this.httpService
  //     .get(token, link)
  //     .pipe(catchError(this.handleError<any>('addNewProgram')));
  // }
  //  family profile , nominated beneficaries
  postNominatedBeneficary(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('death-benefit-nomination/nominated-beneficary')}`,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  /**
   * Handle error
   * @param string operation
   * @param T result
   */
  handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      const responseCode = error.status;
      if (error.status == '401' || error.statusText == 'Unauthorized') {
        this.auth.logout();
      }
      // if (ResponseCodes.unauthorized.indexOf(responseCode) > -1) {
      //   this.customEventService.dispatchEvent('unAuthorizeEvent', 'logoutUser');
      // }

      return throwError(error);
    };
  }
}
